import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { debounce } from "lodash";
import { LinearProgress } from "@mui/material";
import { useDispatch } from "react-redux";

import Sidebar from "../Components/Sidebars/main";
import NavBar from "../Components/Navbars/main";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import ResponsiveTabContainer from "../Components/DocPage/new-doc-page/ResponsiveTabContainer";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
import Footer from "../Components/common/footer";
import useTabsData from "../Components/DocPage/new-doc-page/hooks/useGetTabsData";
// import useSearchData from "../Components/DocPage/new-doc-page/hooks/useSearchData";
import SimpleIcon from "../assets/images/simple-icon.svg";
import DetailIcon from "../assets/images/detail.svg";
import DatesIcon from "../assets/images/dates.svg";
import AssembleDocument from "../Components/AssembleDocument/AssembleDocument";
import NewDocumentTab from "../Components/DocPage/new-tab/new-document-tab";
import NewDetailedTab from "../Components/DocPage/new-tab/new-detailed-tab";
import AllDocs from "../Components/DocPage/AllDocs";
import Treatment from "../Components/DocPage/Treatment";
import TabData from "../Components/DocPage/TabData";
import { fetchPageObject, fetchShakespeareStatus, getCaseId, getClientId } from "../Utils/helper";
import NewSummary from "../Components/DocPage/new-summary";
// import useGetSummaryData from "../Components/DocPage/new-doc-page/hooks/useGetSummaryData";
import addIconGold from "../assets/Add-icon-gold.svg";
import { api_without_cancellation } from "../api/api";
import "./new-doc.css";
const NewDocPage = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [_activeTabName, setActiveTabName] = useState("All");
  const [currentPage, setCurrentPage] = useState("summary");
  const [showAssemblyModal, setShowAssemblyModal] = useState(false);
  const dispatch = useDispatch();
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 15).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const { pageSlots, unsortedCount, allCount, refetch } = useTabsData();
  // const { _tabData, loading: searchLoading, refetch: fetchSearch } = useSearchData(activeTab);
  // const { tabData: data, loading } = useGetSummaryData(activeTab);
  const [searchTerm, setSearchTerm] = useState("");
  const [query, setQuery] = useState("");
  const [loadingNew, setLoadingNew] = useState(false);
  const [simpleDetailData, setSimpleDetailData] = useState([]);
  const PGSIZE = currentPage === "summary" ? 40 : 27;
  const [pageNo, setPageNo] = useState(1);

  const fetchDataforRefetch = useCallback(
    async ({ query }) => {
      try {
        setLoadingNew(true);
        const res = await api_without_cancellation.get("/api/doc-page/list-docs-centric/", {
          params: {
            case_id: getCaseId(),
            client_id: getClientId(),
            page_id: activeTab === "all" ? "" : activeTab,
            page: pageNo,
            page_size: PGSIZE,
            query,
          },
        });
        setSimpleDetailData(res.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingNew(false);
      }
    },
    [pageNo, PGSIZE]
  );

  const fetchDataforRefetch2 = useCallback(
    async ({ query, activeTab2 }) => {
      try {
        setLoadingNew(true);
        const res = await api_without_cancellation.get("/api/doc-page/list-docs-centric/", {
          params: {
            case_id: getCaseId(),
            client_id: getClientId(),
            page_id: activeTab2 === "all" ? "" : activeTab2,
            page: pageNo,
            page_size: PGSIZE,
            query,
          },
        });
        setSimpleDetailData(res.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingNew(false);
      }
    },
    [pageNo, PGSIZE]
  );

  const [rowsTabData, setRowsTabData] = useState(null);
  const [rowsDataLoading, setRowsDataLoading] = useState(false);
  const refetchRowsData = useCallback(async ({ query }) => {
    try {
      setRowsDataLoading(true);
      const res = await api_without_cancellation.get("/api/doc-page/doc-page-rows/", {
        params: {
          case_id: getCaseId(),
          client_id: getClientId(),
          page_id: activeTab === "all" ? "" : activeTab,
          query,
        },
      });
      setRowsTabData(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setRowsDataLoading(false);
    }
  }, []);

  const refetchRowsData2 = useCallback(async ({ query, activeTab2 }) => {
    try {
      setRowsDataLoading(true);
      const res = await api_without_cancellation.get("/api/doc-page/doc-page-rows/", {
        params: {
          case_id: getCaseId(),
          client_id: getClientId(),
          page_id: activeTab2 === "all" ? "" : activeTab2,
          query,
        },
      });
      setRowsTabData(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setRowsDataLoading(false);
    }
  }, []);

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        fetchDataforRefetch({ query: value });
        refetchRowsData({ query: value });
        refetch({ query: value });
      }, 500),
    [fetchDataforRefetch, refetch]
  );

  const handleInputChange = useCallback(
    (event) => {
      const value = event.target.value;
      setSearchTerm(value);
      setQuery(value);
      debouncedSearch(value);
    },
    [debouncedSearch]
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingNew(true);
        const res = await api_without_cancellation.get("/api/doc-page/list-docs-centric/", {
          params: {
            case_id: getCaseId(),
            client_id: getClientId(),
            page_id: activeTab === "all" ? "" : activeTab,
            page: pageNo,
            page_size: PGSIZE,
            query,
          },
        });
        setSimpleDetailData(res.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingNew(false);
      }
    };

    fetchData();
  }, [pageNo, PGSIZE]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setRowsDataLoading(true);
        const res = await api_without_cancellation.get("/api/doc-page/doc-page-rows/", {
          params: {
            case_id: getCaseId(),
            client_id: getClientId(),
            page_id: activeTab === "all" ? "" : activeTab,
          },
        });
        setRowsTabData(res.data);
      } catch (error) {
        console.error(error);
      } finally {
        setRowsDataLoading(false);
      }
    };

    fetchData();
  }, [pageNo]);

  useEffect(() => {
    fetchShakespeareStatus(getCaseId(), 15, dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const tabsData = [
    {
      id: "summary",
      label: "Summary",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",
      onClick: () => {
        setPageNo(1);
        handlePageChange("summary");
      },
      leftHand: true,
      span: (
        <span
          style={{
            width: "15px",
            height: "15px",
          }}
          className="fw-bold d-flex align-items-center justify-content-center  text-gold"
        >
          <img
            src={DatesIcon}
            style={{
              width: "15px",
              height: "15px",
            }}
            alt="Detail"
          />
        </span>
      ),
    },
    {
      id: "simple",
      label: "Simple",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",

      onClick: () => {
        setPageNo(1);
        handlePageChange("simple");
      },
      leftHand: true,
      span: (
        <span
          style={{
            width: "15px",
            height: "15px",
          }}
          className="fw-bold d-flex align-items-center justify-content-center  text-gold"
        >
          <img
            src={SimpleIcon}
            style={{
              width: "15px",
              height: "15px",
            }}
            alt="Detail"
          />
        </span>
      ),
    },
    {
      id: "detailed",
      label: "Detailed",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",

      onClick: () => {
        setPageNo(1);
        handlePageChange("detailed");
      },
      leftHand: true,
      span: (
        <span
          style={{
            width: "15px",
            height: "15px",
          }}
          className="fw-bold d-flex align-items-center justify-content-center  text-gold"
        >
          <img
            src={DetailIcon}
            style={{
              width: "15px",
              height: "15px",
            }}
            alt="Detail"
          />
        </span>
      ),
    },
    {
      id: "default",
      label: "Doc Rows",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",
      left: "0px",
      onClick: () => handlePageChange("default"),
      leftHand: true,
      span: (
        <span
          style={{
            width: "15px",
            height: "15px",
          }}
          className="fw-bold d-flex align-items-center justify-content-center  text-gold"
        >
          <img
            src={DetailIcon}
            style={{
              width: "15px",
              height: "15px",
            }}
            alt="Detail"
          />
        </span>
      ),
    },
  ];
  const addTab = [
    {
      id: "addAssembly",
      label: "Assembly",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",

      left: "0px",
      onClick: () => setShowAssemblyModal(true),
      leftHand: true,
      span: (
        <span className="fw-bold ic-15 d-flex align-items-center">
          <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
        </span>
      ),
    },
  ];

  const unsortedTab = [
    {
      id: "unsorted",
      label: "Unsorted",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      onClick: () => setActiveTab("unsorted"),
    },
  ];

  const handleSelect = async (selectedTab, selectedTabName) => {
    setActiveTab(selectedTab);
    setActiveTabName(selectedTabName);
    fetchDataforRefetch2({
      query: query,
      activeTab2: selectedTab,
    });
    refetchRowsData2({
      query: query,
      activeTab2: selectedTab,
    });
  };

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);
  const containerHeight = useRef(null);
  const loader = ["simple", "detailed", "summary"].includes(currentPage)
    ? loadingNew
    : rowsDataLoading;
  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName={"15"} />
          <ActionBarComponent
            src={pageObject?.page_icon}
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container invisible-scrollbar" ref={containerHeight}>
            <div
              style={{
                position: "sticky",
                top: "0px",
                zIndex: "10",
                width: "100%",
                background: "white",
              }}
            >
              <div className="d-flex align-items-center m-b-5 p-r-5 w-100 height-25 ps-0">
                <textarea
                  className=" height-25 m-0 note_assign_text note_assign_text-new"
                  // className="note_assign_text slanted-textarea"
                  style={{
                    padding: "0px 10px",
                    resize: "none",
                    width: "100%",
                    height: "25px",
                    border: "2px solid var(--primary-25)",
                  }}
                  placeholder="Type three or more characters to search documents on the case..."
                  value={searchTerm}
                  onChange={handleInputChange}
                />
              </div>

              <ResponsiveTabContainer
                onSelect={handleSelect}
                data={pageSlots}
                allCount={allCount}
                unsortedCount={unsortedCount}
                activeTab={activeTab}
                tabsData={tabsData}
                addTab={addTab}
                photoTab={unsortedTab}
                currentPage={currentPage}
              />
              <div
                style={{
                  width: "100%",
                  justifyContent: "flex-start",
                  background: "var(--primary)",
                  height: "25px",
                  marginBottom: "5px",
                  position: "relative",
                }}
              >
                <span
                  className="fw-bold text-white"
                  style={{
                    height: "25px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textTransform: "capitalize",
                  }}
                >
                  {currentPage === "default" ? "Doc Rows" : currentPage} View
                </span>
                {simpleDetailData?.total_pages &&
                  ["simple", "detailed", "summary"].includes(currentPage) && (
                    <div
                      className=""
                      style={{
                        position: "absolute",
                        top: "0px",
                        right: "9px",
                        height: "25px",
                      }}
                    >
                      <div
                        className="d-flex align-items-center"
                        style={{
                          color: "",
                        }}
                      >
                        <span
                          className=""
                          style={{
                            color: "var(--primary-25)",
                            fontWeight: "600",
                            textTransform: "uppercase",
                            // height: "25px",
                          }}
                        >
                          PAGE:
                        </span>
                        {(() => {
                          const totalPages = simpleDetailData.total_pages;
                          const current = pageNo;
                          let pages = [];

                          if (totalPages <= 22) {
                            pages = Array.from({ length: totalPages }, (_, i) => i + 1);
                          } else {
                            if (current <= 7) {
                              for (let i = 1; i <= 8; i++) {
                                pages.push(i);
                              }
                              pages.push("...");
                              pages.push(totalPages);
                            } else if (current >= totalPages - 3) {
                              pages.push(1);
                              pages.push("...");
                              for (let i = totalPages - 4; i <= totalPages; i++) {
                                pages.push(i);
                              }
                            } else {
                              pages.push(1);

                              if (current - 1 > 2) {
                                pages.push("...");
                              }

                              for (let i = current - 1; i <= current + 1; i++) {
                                pages.push(i);
                              }

                              if (current + 1 < totalPages - 1) {
                                pages.push("...");
                              }

                              pages.push(totalPages);
                            }
                          }

                          return pages.map((page, idx) => {
                            if (page === "...") {
                              return (
                                <span
                                  key={`ellipsis-${idx}`}
                                  className="px-2"
                                  style={{ color: "white" }}
                                >
                                  ...
                                </span>
                              );
                            }

                            return (
                              <button
                                key={page}
                                style={{
                                  color: page === pageNo ? "white" : "var(--primary-25)",
                                  fontWeight: "600",
                                  height: "25px",

                                  width: "20px",
                                }}
                                className="bg-hover-page-nos p-0"
                                onClick={() => setPageNo(page)}
                              >
                                {page}
                              </button>
                            );
                          });
                        })()}
                      </div>
                    </div>
                  )}
              </div>
            </div>
            {loader ? (
              <>
                <div
                  style={{
                    width: "100%",
                    padding: "5px",
                    margin: "25px auto",
                    color: "var(--primary)",
                  }}
                  className="m-t-25"
                >
                  <LinearProgress key={loader} color="inherit" />
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "5px",
                    margin: "25px auto",
                    color: "var(--primary)",
                  }}
                  className="m-t-25"
                >
                  <LinearProgress color="inherit" />
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "5px",
                    margin: "25px auto",
                    color: "var(--primary)",
                  }}
                  className="m-t-25"
                >
                  <LinearProgress color="inherit" />
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "5px",
                    margin: "25px auto",
                    color: "var(--primary)",
                  }}
                  className="m-t-25"
                >
                  <LinearProgress color="inherit" />
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "5px",
                    margin: "25px auto",
                    color: "var(--primary)",
                  }}
                  className="m-t-25"
                >
                  <LinearProgress color="inherit" />
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "5px",
                    margin: "25px auto",
                    color: "var(--primary)",
                  }}
                  className="m-t-25"
                >
                  <LinearProgress color="inherit" />
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "5px",
                    margin: "25px auto",
                    color: "var(--primary)",
                  }}
                  className="m-t-25"
                >
                  <LinearProgress color="inherit" />
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "5px",
                    margin: "25px auto",
                    color: "var(--primary)",
                  }}
                  className="m-t-25"
                >
                  <LinearProgress color="inherit" />
                </div>
              </>
            ) : currentPage === "simple" ? (
              <>
                <NewDocumentTab
                  // data={
                  //   activeTab === "all"
                  //     ? tabData?.data || []
                  //     : // eslint-disable-next-line no-constant-binary-expression
                  //       [
                  //         {
                  //           page_docs: tabData?.data,
                  //           panels: tabData?.panels,
                  //           page: tabData?.page,
                  //         },
                  //       ] || []
                  // }
                  data={simpleDetailData}
                  // data={tabData?.data || []}
                  loading={loader}
                  refetchData={async () => {
                    fetchDataforRefetch({ query: query });
                    refetch({ query: query });
                    // refetch({
                    //   query: query,
                    // });
                    // fetchSearch({
                    //   query: query,
                    // });
                  }}
                  refetchLoading={loader}
                  pageView={currentPage}
                />
              </>
            ) : currentPage === "detailed" ? (
              <>
                <NewDetailedTab
                  // data={
                  //   activeTab === "all"
                  //     ? tabData?.data || []
                  //     : // eslint-disable-next-line no-constant-binary-expression
                  //       [
                  //         {
                  //           page_docs: tabData?.data,
                  //           panels: tabData?.panels,
                  //           page: tabData?.page,
                  //         },
                  //       ] || []
                  // }
                  data={simpleDetailData}
                  // data={tabData?.data || []}
                  loading={loader}
                  refetchData={async () => {
                    fetchDataforRefetch({ query: query });
                    refetch({ query: query });
                    // refetch({
                    //   query: query,
                    // });
                    // fetchSearch({
                    //   query: query,
                    // });
                  }}
                  refetchLoading={loader}
                  pageView={currentPage}
                />
              </>
            ) : currentPage === "summary" ? (
              <>
                <NewSummary
                  doc={simpleDetailData}
                  containerHeight={containerHeight}
                  refetchData={async () => {
                    fetchDataforRefetch({ query: query });
                    refetch({ query: query });
                    // refetch({
                    //   query: query,
                    // });
                    // fetchSearch({
                    //   query: query,
                    // });
                  }}
                />
              </>
            ) : activeTab === "all" ? (
              <>
                {/* <AllDocs
                  data={tabData?.data || []}
                  loading={searchLoading}
                  refetchData={async () => {
                    refetch({
                      query: query,
                    });
                    fetchSearch({
                      query: query,
                    });
                  }}
                  refetchLoading={searchLoading}
                  pageView={currentPage}
                /> */}
                <AllDocs
                  data={rowsTabData}
                  loading={rowsDataLoading}
                  refetchData={async () => {
                    refetchRowsData({ query: query });
                    refetch({ query: query });
                    fetchDataforRefetch({ query: query });
                  }}
                  refetchLoading={rowsDataLoading}
                  pageView={currentPage}
                />
              </>
            ) : activeTab === 8 ? (
              <>
                <Treatment
                  data={rowsTabData}
                  refetchData={async () => {
                    refetchRowsData({ query: query });
                    refetch({ query: query });
                    fetchDataforRefetch({ query: query });
                  }}
                  refetchLoading={rowsDataLoading}
                  pageView={currentPage}
                />
              </>
            ) : activeTab === "unsorted" ? (
              <>
                <TabData
                  activeTab={activeTab}
                  data={rowsTabData?.unsorted}
                  refetchData={async () => {
                    refetchRowsData({ query: query });
                    refetch({ query: query });
                    fetchDataforRefetch({ query: query });
                  }}
                  refetchLoading={rowsDataLoading}
                  pageView={currentPage}
                />
              </>
            ) : (
              <>
                {/* <TabData
                  activeTab={activeTab}
                  data={tabData || []}
                  refetchData={async () => {
                    refetch({
                      query: query,
                    });
                    fetchSearch({
                      query: query,
                    });
                  }}
                  refetchLoading={searchLoading}
                  pageView={currentPage}
                /> */}
                <TabData
                  activeTab={activeTab}
                  data={rowsTabData?.data}
                  refetchData={async () => {
                    refetchRowsData({ query: query });
                    refetch({ query: query });
                  }}
                  refetchLoading={rowsDataLoading}
                  pageView={currentPage}
                />
              </>
            )}

            <NotesSectionDashboard pageName={"Docs"} pageObj={pageObject} />
          </div>
        </div>
      </div>

      <Footer />

      {showAssemblyModal && (
        <AssembleDocument
          show={showAssemblyModal}
          handleClose={() => setShowAssemblyModal(false)}
          activeTab={activeTab}
        />
      )}
    </>
  );
};

export default NewDocPage;
